export default {
	action: '操作',
	amount: '金額',
	available_balance: '可用餘額:',
	credit_info: '信用資訊',
	credit_invoice_no: '充值發票編號',
	email_bound: '已綁定郵箱',
	email_unbound: '未綁定郵箱',
	pay: '支付',
	recharge_now: '立即充值',
	set_password_notice: '請盡快設定密碼',
	status: '狀態',
	unverified: '未實名認證',
	verified: '已實名認證',
	view_invoice: '查看發票',
	welcome_back: '歡迎回來，',
}
